var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.relatedItems.length > 0)?_c('div',{class:['item-wrapper', 'pa-1', {'mobile': _vm.sMobile}]},_vm._l((_vm.relatedItems),function(relatedItem){return _c('ItemCard',{key:relatedItem.id,attrs:{"item":relatedItem}})}),1):_c('div',{staticClass:"grey--text"},[_vm._v(" "+_vm._s(_vm.$t('item.terms.noRelatedItems'))+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }